import React from 'react';
import PropTypes from 'prop-types';

import TextArea from '../../../../components/TextArea';
import Header from '../../../../components/Header';
import messages from './messages';
import '../styles.css';

const OpeningStatement = ({ onChange, initialValue, formatMessage }) => (
  <div>
    <Header as="h6">{formatMessage(messages.openingStatementSubtitle)}</Header>
    <TextArea
      placeholder={formatMessage(messages.openingStatement)}
      value={initialValue.value}
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      styleName="opening-statement"
    />
  </div>
);

OpeningStatement.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default OpeningStatement;
